import { useThemeProps } from "../../wsui/base";

import PostsModuleButtonItem from "./PostsModuleButtonItem.jsx";
import PostsModuleCardItem from "./PostsModuleCardItem.jsx";
import PostsModuleTeaserItem from "./PostsModuleTeaserItem.jsx";

function defaultVariantMapping({ variant }) {
  switch (variant) {
    case "card":
    default:
      return PostsModuleCardItem;
    case "teaser":
      return PostsModuleTeaserItem;
    case "button":
      return PostsModuleButtonItem;
  }
}

export default function PostsModuleItem(props) {
  props = useThemeProps({ props, name: "MunicipioPostsModuleItem" });
  let {
    item,
    visibleFields,
    variant,
    variantMapping = {},
    displayMode,
    ...restProps
  } = props;
  const ownerState = {
    displayMode,
    item,
    visibleFields,
    variant,
    variantMapping,
    ...restProps,
  };
  const Component =
    (typeof variantMapping === "function"
      ? variantMapping(ownerState, defaultVariantMapping)
      : variantMapping[variant]) || defaultVariantMapping(ownerState);

  return <Component item={item} visibleFields={visibleFields} {...restProps} />;
}
